import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/about/index.jsx");
